"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEmpty(obj) {
    for (var x in obj)
        return false;
    return true;
}
exports.isEmpty = isEmpty;
function createUUID() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
}
exports.createUUID = createUUID;
function addNoScroll() {
    if (document.body.className.indexOf('p-no-scroll') === -1) {
        document.body.classList.add('p-no-scroll');
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (iOS) {
            var scrollPos = document.body.scrollTop;
            document.body.style.top = '-' + scrollPos + 'px';
            document.body.style.position = 'fixed';
            document.body.style.width = 100 + '%';
            document.body.style.height = '100vh';
        }
    }
}
exports.addNoScroll = addNoScroll;
function removeNoScroll() {
    if (document.body.className.indexOf('p-no-scroll') > -1) {
        document.body.classList.remove('p-no-scroll');
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (iOS) {
            var styleTop = document.body.style.top;
            var scrollPos = parseInt(styleTop.substring(1, styleTop.length - 2));
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('width');
            document.body.style.removeProperty('height');
            document.body.scrollTop = scrollPos;
        }
    }
}
exports.removeNoScroll = removeNoScroll;
function printWarning(warnCheck, msg) {
    warnCheck() && console.error(msg);
}
var $devWarnOn = function (warnCheck, msg) { };
exports.$devWarnOn = $devWarnOn;
if (typeof process !== 'object' || !process.env || process.env.NODE_ENV !== 'production') {
    exports.$devWarnOn = $devWarnOn = printWarning;
}



//////////////////
// WEBPACK FOOTER
// ../player-common-controls/node_modules/player-core/utils.js
// module id = 563
// module chunks = 0